<template>
  <div class="academy">
    <div class="academy__hero">
      <div class="academy__hero-bg">
        <div class="academy__hero-bg__triangle"></div>
      </div>
    </div>
    <header class="academy__header">
      <div class="academy__header-left">
        <a class="academy__logo-link" href="/calendar">
          <span class="academy__logo-back">&larr; Tilbage til</span>
          <svg class="academy__logo" enable-background="new 16.5 363.8 484.1 110.9" viewBox="16.5 363.8 484.1 110.9" xmlns="http://www.w3.org/2000/svg"><path fill="#ffffff" d="m118 473.3c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.6-15.2 11.3-26.9 11.3zm2.9-10.1c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.5 13.6 7.5zm71.7 10.7c-12.4 0-21.2-2.6-26.4-7.8s-7.8-14.1-7.8-26.7c0-13.9 3.3-24.5 9.9-31.9 6.6-7.3 16.6-11 30.1-11 6.6 0 11.4.6 14.3 1.8 3 1.2 4.5 3.1 4.5 5.5 0 3-1.1 5.9-3.2 8.6-7.5-3.9-14-5.9-19.3-5.9-7 0-11.9 2.2-14.9 6.7-2.9 4.4-4.4 11.4-4.4 20.9 0 9.8 1.4 17.1 4.3 22.1s8.1 7.4 15.7 7.4c5.8 0 12.5-1.9 20.1-5.8 1.7 2.3 2.5 4.7 2.5 7.1 0 2.9-2.6 5.1-7.8 6.6-5.2 1.6-11.1 2.4-17.6 2.4zm61.2-77.7c9.3 0 16.3 2.2 20.8 6.6s6.8 11.7 6.8 21.9c0 4.5-.8 7.6-2.4 9.3-1.6 1.8-5.1 2.6-10.6 2.6h-33.3c.1 8.2 1.7 14.6 4.9 19.3s8.8 7 16.9 7c7.5 0 14.6-2 21-5.9 2.2 2.2 3.2 4.4 3.2 6.9 0 3.4-2.8 5.7-8.3 7.1-5.6 1.4-11.8 2-18.8 2-12.9 0-22.1-2.7-27.7-8.2s-8.4-14.6-8.4-27.6c0-12.7 3.2-22.8 9.5-30.1 6.4-7.2 15.1-10.9 26.4-10.9zm-2.9 10.1c-5 0-8.8 1.8-11.5 5.4-2.6 3.6-4 9.2-4.3 16.9h7.8c8.2 0 13.9-.2 16.9-.5s4.7-.9 5.2-1.6c.5-.8.7-2.2.7-4.2 0-5-1.3-8.9-3.8-11.7-2.5-2.9-6.1-4.3-11-4.3zm56.5.9c5-3.3 9.9-5.8 14.7-7.3 4.9-1.6 9.2-2.3 13-2.3 6.7 0 11.7 1.5 15.1 4.6s5.1 9 5.1 17.7c0 27 .4 41.4 1.2 43s2.6 2.4 5.4 2.3c.6 1.5.8 2.9.8 4.4 0 1.4-.4 2.3-1.3 2.7-.9.5-2.4.7-4.8.7-7 0-11.3-.1-12.8-.3-1.6-.2-2.6-.7-3.2-1.6s-.8-2.3-.8-4.4v-32.5c0-10.4-1.1-17.2-3.3-20.7-2.2-3.4-5.7-5.1-10.6-5.1-4.2 0-7.8 1.2-10.8 3.5s-4.6 6.6-4.6 12.7v15.9c0 8.9.2 17.1.5 24.6h8.4c.6 1.3.9 2.7.9 4.2 0 1.4-.3 2.3-.8 2.8-.6.5-1.6.8-3.2.8h-29.6c-.7-1.6-1-3.1-1-4.5 0-1.1.3-1.9.8-2.5.6-.5 1.5-.8 2.7-.8h5.2c.4-8 .6-17.8.6-29.4 0-14.8-.6-23.4-1.7-25.8-1.2-2.4-3.4-3.5-6.6-3.5-.7-1.4-1-2.9-1-4.4 0-1.4.5-2.2 1.6-2.6s7.7-.8 20-1.2c.4 2.4.4 5.3.1 9zm156.5 66.7c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.5-15.2 11.3-26.9 11.3zm2.9-10.2c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.6 13.6 7.5zm-422.3 10.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7zm352.3 18.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7z"/></svg>
        </a>
        <span class="academy__header-divider">Academy</span>
        <span class="academy__header-sep">|</span>
        <span class="academy__school-name">{{ schoolName }}</span>
      </div>
      <nav class="academy__tabs">
        <template v-for="tab in academyTabs">
          <button
            v-if="!tab.comingSoon"
            :key="tab.id"
            type="button"
            class="academy__tab"
            :class="{ 'academy__tab--active': activeShowcaseId === tab.id }"
            @click="switchShowcase(tab.id)">
            {{ tab.label }}
          </button>
          <span
            v-else
            :key="'soon-' + tab.label"
            class="academy__tab academy__tab--soon"
            aria-disabled="true">
            <span class="academy__tab-label">{{ tab.label }}</span>
            <span class="academy__tab-soon-note">Kommer snart</span>
          </span>
        </template>
      </nav>
    </header>

    <div class="academy__body" v-if="!isLoading && videos.length">
      <div class="academy__player-section">
        <div class="academy__player-wrap">
          <iframe
            ref="vimeoPlayer"
            :src="activeVideoSrc"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
            allowfullscreen>
          </iframe>
        </div>
        <div class="academy__video-info">
          <h2 class="academy__video-title">{{ activeVideo.name }}</h2>
          <div class="academy__video-desc" v-if="activeVideo.description_html" v-html="activeVideo.description_html"></div>
        </div>
      </div>

      <div class="academy__playlist">
        <div
          v-for="(video, index) in videos"
          :key="video.uri"
          class="academy__playlist-item"
          :class="{ 'academy__playlist-item--active': activeVideo && activeVideo.uri === video.uri }"
          @click="selectVideo(video)">
          <div class="academy__playlist-item-left">
            <i class="academy__play-icon"></i>
            <span class="academy__playlist-number">{{ index + 1 }}.</span>
            <span class="academy__playlist-name">{{ video.name }}</span>
          </div>
          <span class="academy__playlist-duration">({{ formatDuration(video.duration) }})</span>
          <div class="academy__playlist-progress">
            <div class="academy__playlist-progress-bar" :style="{ width: getProgress(video) + '%' }"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="academy__loading" v-if="isLoading">
      <div class="academy__spinner"></div>
    </div>

    <div class="academy__empty" v-if="!isLoading && !videos.length">
      <p>Ingen videoer fundet.</p>
    </div>
  </div>
</template>

<script>
import docendo from '../../docendo.js'

var VIMEO_USER_ID = '165243599'
var VIMEO_TOKEN = '81c5429f7c98d1aed4901a829c791710'
var ACADEMY_TABS = [
  { id: '11997053', label: 'Introkursus' },
  { id: '12164971', label: 'Vikardækning' },
  { id: '12259500', label: 'Skemalægning' },
  { id: '12164973', label: 'For medarbejdere' },
  { id: '12286610', label: 'Drift af skemaer' }
]

export default {
  name: 'Academy',
  data () {
    return {
      videos: [],
      activeVideo: null,
      isLoading: false,
      shouldAutoplay: false,
      videoProgress: {},
      activeShowcaseId: ACADEMY_TABS[0].id
    }
  },
  computed: {
    academyTabs () {
      return ACADEMY_TABS
    },
    schoolName () {
      return window.SCHOOL ? window.SCHOOL.name : ''
    },
    activeVideoSrc () {
      if (!this.activeVideo) return ''
      var url = this.activeVideo.player_embed_url || ''
      if (this.shouldAutoplay && url) {
        var separator = url.indexOf('?') > -1 ? '&' : '?'
        url = url + separator + 'autoplay=1'
      }
      return url
    }
  },
  beforeMount () {
    this.$store.dispatch('getUser')
  },
  watch: {
    '$store.state.isUserLoaded': function (loaded) {
      if (loaded) {
        var schoolId = this.$route.params.school_id
        docendo.trackEvent(schoolId, 'academy_page_view')
      }
    },
    activeVideoSrc: function () {
      var self = this
      self.$nextTick(function () {
        self.initVimeoPlayer()
      })
    }
  },
  mounted () {
    this.loadProgress()
    this.loadVimeoSDK()
    this.fetchVideos()
  },
  beforeDestroy () {
    if (typeof this.saveProgress === 'function') {
      this.saveProgress()
    }
    if (this._vimeoPlayer) {
      this._vimeoPlayer.off('timeupdate')
      this._vimeoPlayer = null
    }
  },
  methods: {
    fetchVideos () {
      var self = this
      var activeTab = null
      for (var i = 0; i < ACADEMY_TABS.length; i++) {
        if (ACADEMY_TABS[i].id === self.activeShowcaseId) {
          activeTab = ACADEMY_TABS[i]
          break
        }
      }

      if (activeTab && activeTab.videoId) {
        self.isLoading = true
        var videoUrl = 'https://api.vimeo.com/videos/' + activeTab.videoId + '?fields=uri,name,description,description_html,duration,player_embed_url'
        window.fetch(videoUrl, {
          headers: {
            Authorization: 'Bearer ' + VIMEO_TOKEN
          }
        }).then(function (res) {
          return res.json()
        }).then(function (json) {
          if (json && json.uri) {
            if (activeTab.videoHash && json.player_embed_url && json.player_embed_url.indexOf('h=') === -1) {
              var sep = json.player_embed_url.indexOf('?') > -1 ? '&' : '?'
              json.player_embed_url = json.player_embed_url + sep + 'h=' + activeTab.videoHash
            }
            self.videos = [json]
            self.activeVideo = json
          } else {
            self.videos = [{
              uri: '/videos/' + activeTab.videoId,
              name: activeTab.label,
              duration: 0,
              description_html: '',
              player_embed_url: 'https://player.vimeo.com/video/' + activeTab.videoId + (activeTab.videoHash ? '?h=' + activeTab.videoHash : '')
            }]
            self.activeVideo = self.videos[0]
          }
          self.isLoading = false
        }).catch(function () {
          self.videos = [{
            uri: '/videos/' + activeTab.videoId,
            name: activeTab.label,
            duration: 0,
            description_html: '',
            player_embed_url: 'https://player.vimeo.com/video/' + activeTab.videoId + (activeTab.videoHash ? '?h=' + activeTab.videoHash : '')
          }]
          self.activeVideo = self.videos[0]
          self.isLoading = false
        })
        return
      }

      var url = 'https://api.vimeo.com/users/' + VIMEO_USER_ID + '/albums/' + self.activeShowcaseId + '/videos?fields=uri,name,description,description_html,duration,player_embed_url&sort=manual&per_page=100'
      self.isLoading = true
      window.fetch(url, {
        headers: {
          Authorization: 'Bearer ' + VIMEO_TOKEN
        }
      }).then(function (res) {
        return res.json()
      }).then(function (json) {
        self.videos = json.data || []
        if (self.videos.length) {
          self.activeVideo = self.videos[0]
        }
        self.isLoading = false
      }).catch(function () {
        self.videos = []
        self.isLoading = false
      })
    },
    switchShowcase (showcaseId) {
      if (!showcaseId) return
      if (this.activeShowcaseId === showcaseId) return
      this.activeShowcaseId = showcaseId
      this.shouldAutoplay = false
      this.fetchVideos()
    },
    selectVideo (video) {
      this.shouldAutoplay = true
      this.activeVideo = video
    },
    formatDuration (seconds) {
      if (!seconds && seconds !== 0) return ''
      var m = Math.floor(seconds / 60)
      var s = String(seconds % 60).padStart(2, '0')
      return (m < 10 ? '0' : '') + m + ':' + s
    },
    getProgress (video) {
      return this.videoProgress[video.uri] || 0
    },
    loadProgress () {
      try {
        var stored = window.localStorage.getItem('academy_video_progress')
        if (stored) {
          this.videoProgress = JSON.parse(stored)
        }
      } catch (e) {}
    },
    saveProgress () {
      try {
        window.localStorage.setItem('academy_video_progress', JSON.stringify(this.videoProgress))
      } catch (e) {}
    },
    loadVimeoSDK () {
      if (window.Vimeo) return
      var self = this
      var script = document.createElement('script')
      script.src = 'https://player.vimeo.com/api/player.js'
      script.onload = function () {
        if (self.activeVideo) {
          self.$nextTick(function () {
            self.initVimeoPlayer()
          })
        }
      }
      document.head.appendChild(script)
    },
    initVimeoPlayer () {
      var self = this
      if (self._vimeoPlayer) {
        self._vimeoPlayer.off('timeupdate')
        self._vimeoPlayer = null
      }
      if (!window.Vimeo || !self.$refs.vimeoPlayer) return
      var player = new window.Vimeo.Player(self.$refs.vimeoPlayer)
      self._vimeoPlayer = player
      player.on('timeupdate', function (data) {
        if (!self.activeVideo) return
        var pct = Math.round(data.percent * 100)
        var current = self.videoProgress[self.activeVideo.uri] || 0
        if (pct > current) {
          self.$set(self.videoProgress, self.activeVideo.uri, pct)
        }
        var now = Date.now()
        if (!self._lastProgressSave || now - self._lastProgressSave > 3000) {
          self._lastProgressSave = now
          self.saveProgress()
        }
      })
    }
  }
}
</script>

<style scoped>
.academy {
  min-height: 100vh;
  background: #edf0f5;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  position: relative;
  overflow: hidden;
}

.academy__hero {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 750px;
  z-index: 0;
  pointer-events: none;
}

.academy__hero-bg {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 750px;
  overflow: hidden;
  transform: skewY(-12deg);
  transform-origin: 0;
  background: #4553ff;
  background: linear-gradient(90deg, #4553ff, #7f7fd5);
}

.academy__hero-bg__triangle {
  width: 100%;
  height: 150px;
  background: hsla(0, 0%, 100%, 0.1);
}

.academy__header {
  position: relative;
  z-index: 1;
  padding: 1.25rem 2rem;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.academy__header-left {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  color: #fff;
}

.academy__logo-link {
  display: flex;
  align-items: flex-end;
  text-decoration: none;
  overflow: hidden;
}

.academy__logo-back {
  display: inline-block;
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.85rem;
  font-weight: 500;
  opacity: 0;
  transition: max-width 0.3s ease, opacity 0.25s ease, margin 0.3s ease;
  margin-right: 0;
}

.academy__logo-link:hover .academy__logo-back {
  max-width: 5em;
  opacity: 1;
  margin-right: 0.4rem;
}

.academy__logo {
  width: 120px;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

.academy__logo-link:hover .academy__logo {
  transform: translateX(2px);
}

.academy__header-divider {
  font-size: 1.1rem;
  font-weight: 500;
  opacity: 0.85;
  margin-left: 0.25rem;
}

.academy__header-sep {
  opacity: 0.5;
  margin: 0 0.15rem;
}

.academy__school-name {
  font-size: 1.1rem;
  font-weight: 400;
  opacity: 0.85;
}

.academy__tabs {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.academy__tab {
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  font-family: inherit;
}

.academy__tab:hover {
  background: rgba(255, 255, 255, 0.35);
}

.academy__tab--active {
  background: #fff;
  color: var(--primary, #6772e5);
}

.academy__tab--soon {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  padding: 0.45rem 1.25rem;
  opacity: 0.72;
  cursor: not-allowed;
  user-select: none;
}

.academy__tab--soon:hover {
  background: rgba(255, 255, 255, 0.2);
}

.academy__tab-label {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.2;
}

.academy__tab-soon-note {
  font-size: 0.75rem;
  font-weight: 500;
  opacity: 0.85;
  line-height: 1.2;
}

.academy__body {
  position: relative;
  z-index: 1;
  display: flex;
  max-width: 1600px;
  margin: 2rem auto;
  padding: 0 1.5rem;
  gap: 1.5rem;
  align-items: flex-start;
}

.academy__player-section {
  flex: 1;
  min-width: 0;
  background: #fff;
  box-shadow: 0 30px 60px -12px rgba(50, 50, 93, .25), 0 18px 36px -18px rgba(0, 0, 0, .3);
  border-radius: 16px;
}

.academy__player-wrap {
  position: relative;
  padding-top: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 8px;
  background: #000;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
}

.academy__player-wrap iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.academy__video-info {
  padding: 2rem;
  border-top: 1px solid #eee;
  margin-top: 1rem;
}

.academy__video-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 0.5rem;
}

.academy__video-desc {
  font-size: 1.05rem;
  color: #606c76;
  line-height: 1.55;
  margin: 0;
}

.academy__video-desc p {
  margin: 0 0 0.75rem;
}

.academy__video-desc p:last-child {
  margin-bottom: 0;
}

.academy__video-desc a {
  color: var(--primary, #6772e5);
  text-decoration: underline;
}

.academy__video-desc a:hover {
  opacity: 0.8;
}

.academy__video-desc strong,
.academy__video-desc b {
  font-weight: 600;
}

.academy__playlist {
  width: 400px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  max-height: calc(100vh - (60px + 2rem));
  overflow-y: auto;
}

.academy__playlist-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1rem;
  cursor: pointer;
  transition: background-color 0.1s;
  font-size: 1rem;
}

.academy__playlist-item:first-child {
  border-radius: 8px 8px 0 0;
}

.academy__playlist-item:last-child {
  border-radius: 0 0 8px 8px;
}

.academy__playlist-item:hover {
  background-color: #f4f4f4;
}

.academy__playlist-item--active {
  background-color: #f4f5ff;
  color: var(--primary, #6772e5);
}

.academy__playlist-item--active .academy__playlist-name {
  color: var(--primary, #6772e5);
}

.academy__playlist-item--active .academy__playlist-number {
  color: var(--primary, #6772e5);
}

.academy__playlist-item--active .academy__play-icon::before {
  border-left-color: var(--primary, #6772e5);
}

.academy__playlist-item-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.academy__play-icon {
  position: relative;
  display: block;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  margin-right: 0.5rem;
}

.academy__play-icon::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: auto;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 6px solid #8794a5;
  top: 6px;
  left: 5px;
}

.academy__playlist-number {
  font-size: 1rem;
  color: #8794a5;
  flex-shrink: 0;
  margin-right: 0.5rem;
  font-weight: 600;
}

.academy__playlist-name {
  flex: 1;
  font-size: 1rem;
  color: #2c3e50;
  line-height: 1.4;
  font-weight: 500;
}

.academy__playlist-duration {
  font-size: 0.9rem;
  color: #8794a5;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 0.75rem;
}

.academy__playlist-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(0, 0, 0, 0.06);
}

.academy__playlist-progress-bar {
  height: 100%;
  background: var(--primary, #6772e5);
  transition: width 0.3s ease;
}

.academy__loading {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6rem 0;
}

.academy__spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e0e2ea;
  border-top-color: var(--primary, #6772e5);
  border-radius: 50%;
  animation: academy-spin 0.7s linear infinite;
}

@keyframes academy-spin {
  to { transform: rotate(360deg); }
}

.academy__empty {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 4rem 0;
  color: #8794a5;
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .academy__tabs {
    flex-wrap: wrap;
    justify-content: flex-end;
    row-gap: 0.5rem;
  }

  .academy__header {
    padding: 1rem 1.25rem;
  }

  .academy__body {
    flex-direction: column;
    padding: 1rem;
    margin: 1rem auto;
    gap: 1rem;
  }

  .academy__playlist {
    max-height: 300px;
  }

  .academy__video-title {
    font-size: 1.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// Academy.vue?1c4f733d